import { useUserStore } from '~/stores/user'
import { useToast } from './useToast'
import { useNtaskApi } from './useNtaskApi'

export function useAuth() {

  const AUTH_STORAGE_KEY = 'auth_data'
  const TOKEN_STORAGE_KEY = 'auth_token'


  const user = useUserStore()
  const { showToast } = useToast()
  const { auth } = useNtaskApi()
  const { saveAuthData, clearAuthData } = useAuthStorage()

  const isAuthenticated = computed(() => {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY)
    return !!token && !!user.usuario.foto
  })

  const validateToken = async (): Promise<boolean> => {
    try {
      const token = localStorage.getItem(TOKEN_STORAGE_KEY)
      if (!token) return false

      // Verificar se o token ainda é válido fazendo uma requisição simples
      const response = await auth.authenticateWithToken(token)
      if (response) {
        user.usuario = {
          ...user.usuario,
          ...response.usuario
        } as any
        return true
      }
      return false
    } catch (error) {
      console.error('Token validation failed:', error)
      return false
    }
  }

  const login = async (credentials: { email: string; password: string }) => {
    try {
      const response = await auth.login(credentials) as any

      saveAuthData(response)

      // Os dados do usuário já vêm no response do login
      user.usuario = {
        ...user.usuario,
        ...response.usuario
      } as any
      
      showToast('Login realizado com sucesso!', 'success')
      return true
    } catch (error) {
      showToast('Erro ao fazer login. Verifique suas credenciais.', 'danger')
      return false
    }
  }

  const logout = async () => {
    try {
      await auth.logout()
    } catch (error) {
      console.error('Erro no logout:', error)
    } finally {
      clearAuthData()
      user.usuario.foto = ''
      showToast('Logout realizado com sucesso!', 'info')
    }
  }

  const updateUserProfile = async (profileData: Partial<typeof user.usuario>) => {
    try {
      // TODO: Implementar endpoint de atualização de perfil quando disponível
      console.log('Atualização de perfil não implementada ainda:', profileData)
      showToast('Funcionalidade de atualização de perfil em desenvolvimento.', 'info')
    } catch (error) {
      showToast('Erro ao atualizar perfil.', 'danger')
    }
  }

  const checkAuthStatus = async (): Promise<boolean> => {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY)
    if (!token) return false

    return await validateToken()
  }

  const ehAdmin = (): boolean => {
    try {
      const authData = localStorage.getItem(AUTH_STORAGE_KEY)
      if (!authData) return false
      
      const parsed = JSON.parse(authData)
      return parsed.usuario?.admin === 'S'
    } catch (error) {
      console.error('Erro ao verificar se é admin:', error)
      return false
    }
  }

  const ehTitular = (): boolean => {
    try {
      const authData = localStorage.getItem(AUTH_STORAGE_KEY)
      if (!authData) return false
      
      const parsed = JSON.parse(authData)
      const funcao = parsed.cartorio?.usuario_funcao
      
      return ehAdmin() || funcao === 'TITULAR' || funcao === 'SUBSTITUTO'
    } catch (error) {
      console.error('Erro ao verificar se é titular:', error)
      return false
    }
  }

  return {
    user: computed(() => user.usuario),
    isAuthenticated,
    validateToken,
    login,
    logout,
    updateUserProfile,
    checkAuthStatus,
    ehAdmin,
    ehTitular
  }
} 